import { useCallback, useState } from 'react'
import { parseDateToDeadline, parseHoursToDeadline, parseTimeToDeadline } from 'lib/helper'

const useSelectHoursToDeadline = () => {
  const [hoursToDeadline, setHoursToDeadline] = useState<number>(24)

  const selectDateToDeadline = useCallback(
    (date: string) => {
      setHoursToDeadline((prevState) => {
        if (date === '0') return 0
        return parseHoursToDeadline(date, parseTimeToDeadline(prevState))
      })
    },
    [setHoursToDeadline]
  )

  const selectTimeToDeadline = useCallback(
    (time: string) => {
      setHoursToDeadline((prevState) => {
        return parseHoursToDeadline(parseDateToDeadline(prevState), time)
      })
    },
    [setHoursToDeadline]
  )

  return {
    hoursToDeadline,
    setHoursToDeadline,
    selectDateToDeadline,
    selectTimeToDeadline,
  }
}

export default useSelectHoursToDeadline
